import { AuthContext } from '@enter/core';
import { PageLayout, PageLayoutHeader, PageLayoutRow, PageLayoutTitle } from 'components';
import React from 'react';
import * as S from '../app.styles';

export class Logout extends React.PureComponent {
    public static contextType = AuthContext;
    public render(): React.ReactElement {
        return (
            <S.Section>
                <PageLayout>
                    <PageLayoutRow>
                        <PageLayoutHeader>
                            <PageLayoutTitle>You have been logged out.</PageLayoutTitle>
                        </PageLayoutHeader>
                    </PageLayoutRow>
                    <PageLayoutRow>
                        Please login again.
                        <S.Button onClick={this.handleClick}>Login</S.Button>
                    </PageLayoutRow>
                </PageLayout>
            </S.Section>
        );
    }
    private readonly handleClick = (): void => {
        this.context && (this.context as any).logoutAndRedirect();
    };
}
